<template>
  <div class="update-static-box">
    <back-box>
      <div style="padding:40px">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="预警参数">
            <el-select
              v-model="form.attributeId"
              placeholder="请选择"
              @visible-change="handleAttributesChange"
              style="width:100%"
            >
              <el-option
                v-for="dict in attributesOptions"
                :key="dict.attributeId"
                :label="dict.name"
                :title="dict.name"
                :value="dict.attributeId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预警阈值">
            <div class="row-bg">
              <el-row>
                <el-col :span="5">
                  <div class="text-center">适宜上限</div>
                </el-col>
                <el-col :span="7">
                  <el-input
                    v-model="form.urgentMin"
                    placeholder="请输入"
                    :maxlength="10"
                    type="number"
                  >
                    <span slot="suffix">度</span>
                  </el-input>
                </el-col>
                <el-col :span="5">
                  <div class="text-center">适宜下限</div>
                </el-col>
                <el-col :span="7">
                  <el-input
                    v-model="form.aberrantMax"
                    placeholder="请输入"
                    :maxlength="10"
                    type="number"
                  >
                    <span slot="suffix">度</span>
                  </el-input>
                </el-col>
              </el-row>
              <el-row style="margin-top:10px">
                <el-col :span="5">
                  <div class="text-center">生理上限</div>
                </el-col>
                <el-col :span="7">
                  <el-input
                    v-model="form.urgentMax"
                    placeholder="请输入"
                    :maxlength="10"
                    type="number"
                  >
                    <span slot="suffix">度</span>
                  </el-input>
                </el-col>
                <el-col :span="5">
                  <div class="text-center">生理下限</div>
                </el-col>
                <el-col :span="7">
                  <el-input
                    v-model="form.aberrantMin"
                    placeholder="请输入"
                    :maxlength="10"
                    type="number"
                  >
                    <span slot="suffix">度</span>
                  </el-input>
                </el-col>
              </el-row>
            </div>
            <el-popover placement="bottom" trigger="hover">
              <img src="@/assets/image/phy-upper-limit.png" alt />
              <div class="item" slot="reference">示意图</div>
            </el-popover>
          </el-form-item>
          <el-form-item label="触发时长" prop="duration">
            <el-input
              style="width:100%"
              v-model="form.duration"
              placeholder="请输入触发时长"
              type="number"
              min="0"
            >
              <span slot="suffix">分钟</span>
            </el-input>
          </el-form-item>
          <el-form-item label="预警间隔" prop="intervals">
            <el-input
              style="width:100%"
              v-model="form.intervals"
              placeholder="请输入间隔时长"
              type="number"
              min="0"
            >
              <span slot="suffix">分钟</span>
            </el-input>
          </el-form-item>
          <el-form-item label="次数上限" prop="frequency">
            <el-input
              style="width:100%"
              v-model="form.frequency"
              placeholder="请输入单日预警次数上限"
              type="number"
              min="0"
            >
              <span slot="suffix">次/天</span>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="btn" type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </back-box>
  </div>
</template>

<script>
import backBox from "../../components/backBox";
import {
  getStrategy,
  updateStrategy,
  attributesById,
} from "@/api/strategy/warning";
export default {
  components: { backBox },
  // 定义属性
  data() {
    return {
      form: {},
      attributesOptions: [],
      // 表单校验
      rules: {},
      strategyId: "",
    };
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getRouteParams() {
      this.strategyId = this.$route.query.id;
    },
    handleAttributesChange(row) {
      if (
        this.attributesOptions == undefined ||
        this.attributesOptions.length == 0
      ) {
        this.handleAttributesById();
      }
    },
    getStrategy() {
      getStrategy(this.strategyId).then((response) => {
        this.form = response.data;
        this.handleAttributesById();
      });
    },
    handleAttributesById() {
      attributesById({ devId: this.form.devId }).then((response) => {
        this.attributesOptions = response.data.attributesList;
      });
    },
    onSubmit() {
      let urgentMaxValue = this.form.urgentMax;
      let urgentMinValue = this.form.urgentMin;
      let aberrantMaxValue = this.form.aberrantMax;
      let aberrantMinValue = this.form.aberrantMin;
      if (urgentMaxValue === "" || urgentMaxValue === undefined) {
        this.msgError("请填写生理上限");
        return;
      }
      if (urgentMinValue === "" || urgentMinValue === undefined) {
        this.msgError("请填写适宜上限");
        return;
      }
      if (aberrantMaxValue === "" || aberrantMaxValue === undefined) {
        this.msgError("请填写适宜下限");
        return;
      }
      if (aberrantMinValue === "" || aberrantMinValue === undefined) {
        this.msgError("请填写生理下限");
        return;
      }
      if (parseFloat(urgentMaxValue) <= parseFloat(urgentMinValue)) {
        this.msgError("生理上限必须大于适宜上限");
        return;
      }
      if (parseFloat(urgentMinValue) <= parseFloat(aberrantMaxValue)) {
        this.msgError("适宜上限必须大于适宜下限");
        return;
      }
      if (parseFloat(aberrantMaxValue) <= parseFloat(aberrantMinValue)) {
        this.msgError("适宜下限必须大于生理下限");
        return;
      }

      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.id != undefined) {
            updateStrategy(this.form).then((response) => {
              if (response.code === 200) {
                this.msgSuccess("修改成功");
                this.$route.go(-1);
              }
            });
          }
        }
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getRouteParams();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getStrategy();
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang='scss'>
.update-static-box {
  margin: 60px 30px;
  .el-select > .el-input {
    border: none;
  }
  .el-form-item__content {
    width: 400px !important;
    text-align: left;
  }
  .el-input__inner {
    height: 40px;
    background-color: rgba(28, 54, 89, 0.2);
    border-radius: 2px;
    color: white;
    border: solid 2px #dddddd !important;
  }
  .el-form-item__label {
    text-align: center;
  }
  .text-center {
    color: white;
    text-align: center;
  }
  .row-bg {
    background-color: rgba(7, 31, 82, 0.2);
    border: 2px solid rgba(164, 196, 230, 0.2);
    padding: 10px;
    .el-input__inner {
      background-color: white;
      color: #333;
    }
  }
  .item {
    position: absolute;
    right: -49px;
    bottom: 2px;
    font-size: 12px;
    color: white;
    line-height: 20px;
    text-decoration: underline;
    cursor: pointer;
  }
  .item:hover {
    color: red;
  }
  .btn {
    text-align: left;
    width: 120px;
    height: 46px;
    background-color: #e88634;
    border-radius: 2px;
    text-align: center;
    font-size: 16px;
    border: none;
  }
}
</style>
